import {createSlice} from '@reduxjs/toolkit';



const initialState = {
  widthDevice: null,
  heightDevice: null,
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    updateDimensions: (state, action) => {
      const {width, height} = action.payload;
      state.widthDevice = typeof width === 'number' ? width : state.widthDevice;
      state.heightDevice =
        typeof height === 'number' ? height : state.heightDevice;
    },
  },
});

export const {updateDimensions} = deviceSlice.actions;
export default deviceSlice.reducer;
